import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeneralService } from '../services/general.service';
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
declare var $: any;
@Component({
  selector: 'app-suivie-coll-dialog',
  templateUrl: './suivie-coll-dialog.component.html',
  styleUrls: ['./suivie-coll-dialog.component.scss'],
})
export class SuivieCollDialogComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public dialogRef: MatDialogRef<SuivieCollDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  //@ViewChild//
  //@ViewChild('htmlEditor') htmlEditor;
  actionD;
  loadData = false;
  du;
  au;
  myTable = '';
  // Angular Editor Supprimer
  // editorConfig: AngularEditorConfig = this.generalService.editorConfig;
  ngOnInit() {
    this.generalService
      .rechercheTable(this.generalService.urlActionD2 + '&val=' + this.data.id)
      .subscribe((actionD) => {
        this.actionD = actionD;

        if (
          this.actionD.avtactionD[0].avtActionD_heureDebPM != null &&
          this.actionD.avtactionD[0].avtActionD_heureDebPM !=
            '00:00:00.0000000' &&
          this.actionD.avtactionD[0].avtActionD_heureDebPM != '00:00' &&
          this.actionD.avtactionD[0].avtActionD_heureDebPM != ''
        ) {
          this.du = this.actionD.avtactionD[0].avtActionD_heureDebPM;
          this.au = this.actionD.avtactionD[0].avtActionD_heureFinPM;
        } else {
          this.du = this.actionD.avtactionD[0].avtActionD_heureDebAM;
          this.au = this.actionD.avtactionD[0].avtActionD_heureFinAM;
        }
        this.setMyTable();
        this.loadData = true;
      });
  }
  setMyTable() {
    if (this.actionD.avtactionD[0].avtActionD_suivi == null)
      this.actionD.avtactionD[0].avtActionD_suivi = '';
    if (this.actionD.avtactionD[0].avtActionD_remarque == null)
      this.actionD.avtactionD[0].avtActionD_remarque = '';
    this.myTable =
      '<table class="tableSuivie" border="1" cellpadding="1" cellspacing="1">' +
      '<thead>' +
      ' <tr>' +
      '<th colspan="2">' +
      '<span ><font size="4">' +
      this.actionD.avtactionD[0].avtActionD_Code +
      '-' +
      this.actionD.avtactionD[0].avtActionD_Info +
      '</font></span><br>' +
      '<span >' +
      this.actionD.avtactionD[0].avtActionD_date.substring(0, 10) +
      'de' +
      this.du.substring(0, 5) +
      ' à ' +
      this.au.substring(0, 5) +
      '</span><br>' +
      '</th>' +
      '</tr>		' +
      '</thead>' +
      '<tbody>' +
      '<tr>' +
      '<td>Actions</td>' +
      '<td>Remarques générales</td>' +
      ' </tr>' +
      ' <tr>  ' +
      '<td>' +
      this.actionD.avtactionD[0].avtActionD_suivi +
      '</td>' +
      ' <td>' +
      this.actionD.avtactionD[0].avtActionD_remarque +
      '</td>' +
      ' </tr>' +
      '</tbody>' +
      '</table> ';
  }
  close() {
    this.dialogRef.close();
  }
  save() {
    //@ViewChild//
    // var htmlTable = $( this.htmlEditor.value )
    // this.actionD.avtactionD[0].avtActionD_suivi =    htmlTable[0].children[1].children[1].children[0].innerHTML;
    // this.actionD.avtactionD[0].avtActionD_remarque = htmlTable[0].children[1].children[1].children[1].innerHTML;
    //@ViewChild//

    this.generalService.enregisterTable(this.actionD).subscribe(
      (data) => {
        alert('enregistré');
      },
      (err) => {
        console.log(err);
      }
    );
    //this.generalService.dialogSuccess();
  }
}
